export { default as DefaultPage } from './DefaultPage';
export { default as BasePage } from './Frui_basedataPage';
export { default as QPGodsPage } from './Frui_qpgoodsPage';
export { default as PlanPage } from './Frui_planPage';


// WEBPACK FOOTER //
// ./src/features/furui/index.js